<div class="user-public-div">
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <form [formGroup]="emailFormSendCodeForm" #loginNgForm="ngForm">
                    <div style="display:flex; flex-direction: column; justify-content: center; align-items: center; gap:2rem; margin:0.5rem;" class="titleLogin">
                        <img class="logoImgPublicSize" class="w-[80%] md:[60%] lg:w-[40%]" src="../../../../assets/image/logo-black.png">
                        <h1 class="loginText text-[16px] lg:text-[20px] text-[#1a1a1a]">{{"Forgot password" | translate}}</h1>
                      </div>
                    <div class="field" style="text-align: center;">
                        <mat-form-field appearance="outline" class="inputField">
                            <mat-label>{{"Email" | translate}}</mat-label>
                            <input matInput type="email" name="email" [(ngModel)]="email" formControlName="email" id="contactemail" 
                            [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                             [email]="true" formControlName="email" required>
                    
                             <mat-error *ngIf="f['email'].touched && f['email'].invalid" [hidden]="emailFormSendCodeForm.valid || emailFormSendCodeForm.untouched">
                                <div *ngIf="f['email'].errors!['required']">{{"Email is required" | translate}}</div>
                                <div *ngIf="f['email'].errors!['email']">{{"Email must be a valid email address" | translate}}</div>

                                <mat-error *ngIf="isEmailPresent" class="help-block"
                                >{{"Email Already Exist" | translate}}</mat-error>

                            </mat-error>

                        </mat-form-field>

                    </div>

                    <div class="sendMailBtn" style="margin:0.5rem;">

                        <button (click)="onSubmit()" mat-raised-button color="primary" class=" text-[13px]" [disabled]="!emailFormSendCodeForm.valid">
                            {{"Send Verification code" | translate}}
                        </button>

                     
                    </div>

                    <div class="form-group col text-center pt-4">
                        <a routerLink="../login" class="btn btn-link pr-0">{{"Login" | translate}}</a>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>